<br />
<div class="center" *ngIf="!requestsCompleted">
  <app-calibrant-load [small]="true"></app-calibrant-load>
</div>

<div *ngIf="requestsCompleted">
  <div class="flex items-center justify-between">
    <h3 class="title-header">Programs</h3>
    <button mat-flat-button color="primary" (click)="addProgram()" automation-locator="add-program-button">Add Program</button>
  </div>
  <br />
  <br />
  <hr />
</div>
<br />
<div class="mat-elevation-z8" matSort *ngIf="requestsCompleted" >
  <table [hidden]="!dataSource" mat-table  [dataSource]="dataSource" style="width: 100%;">
    <ng-container matColumnDef="programName" >
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Program Name</th>
      <td mat-cell *matCellDef="let element">
        <a routerLink="/program/{{element.program.id}}/view">{{element['programName']}}</a>
        <br />
        {{cleanProgramText(element.program.programType, 'programTypes')}}
        <br />
        {{cleanProgramText(element.program.properties.performanceTarget, 'performanceTarget')}}
      </td>
    </ng-container>

    <ng-container matColumnDef="maxOutput">
      <th mat-header-cell *matHeaderCellDef mat-sort-header >Total Max Power Output</th>
      <td mat-cell *matCellDef="let element">{{element.maxOutput }} MW</td>
    </ng-container>

    <ng-container matColumnDef="maxEnergy">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Max Energy Output</th>
      <td mat-cell *matCellDef="let element"> {{element.maxEnergy}} MWh</td>
    </ng-container>

    <ng-container matColumnDef="nominatedKw">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Nominated Power</th>
      <td mat-cell *matCellDef="let element"> {{cleanNumericInput(element, 'nominatedKw')}} kW</td>
    </ng-container>

    <ng-container matColumnDef="pointOfMeasurement">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="normalize">Point of Measurement</th>
      <td mat-cell *matCellDef="let element"> {{cleanProgramText(element['pointOfMeasurement'], 'pointOfMeasurement')}} </td>
    </ng-container>

    <ng-container matColumnDef="marketAuction">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Market Auction</th>
      <td mat-cell *matCellDef="let element"> {{ (element['marketAuction']) ? 'Yes' : 'No' }} </td>
    </ng-container>

    <ng-container matColumnDef="notificationTimeframe">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Notification Lead Time</th>
      <td mat-cell *matCellDef="let element"> {{element['notificationTimeframe']}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Actions</th>
      <td mat-cell *matCellDef="let element">

        <mat-icon color="primary" matRipple matTooltip="Edit program" routerLink="/program/{{element.program.id}}/view" class="icon-link" automation-locator="program-edit-icon">edit</mat-icon>
        <mat-icon color="warn" matRipple (click)="removeProgram(element.program)" class="icon-link" matTooltip="Remove program" automation-locator="program-delete-icon">delete</mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 20, 50]"
                 showFirstLastButtons
[pageIndex]="0"
                 [pageSize]="10"
                 aria-label="Select from program list.">
  </mat-paginator>
</div>
